import {
  SET_REQUEST_CONTEXT,
  SET_REQUEST_DETAILS,
  USER_REGISTRATION_SUCCESS,
  CUISINE_SUCCESS,
} from '../actions/types';

const initialState = {
  host: 'https://example.com',
  apiAuth: false,
  alternateUrls: [],
};

export default function requestReducer(state = initialState, action = {}) {
  switch (action.type) {
    case SET_REQUEST_CONTEXT:
      return {
        ...state,
        ...action.payload,
      };
    case SET_REQUEST_DETAILS:
      return {
        ...state,
        currentUrl: action.payload.url,
        currentQuery: action.payload.query,
      };
    case USER_REGISTRATION_SUCCESS: {
      const { consumer_auth_token: apiAuth } = action.payload;

      return {
        ...state,
        apiAuth,
      };
    }
    case CUISINE_SUCCESS: {
      /**
       * Whenever we receive a set of alternate locales, store these in the
       * request slice of state.
       */
      const { alternate_locale_cuisines: alternateLocales } = action.payload.data;
      const alternateUrls = (alternateLocales || []).map(
        ({ locale, cuisineSlug: cuisine, citySlug: city }) => ({
          locale,
          url: `/${locale.toLowerCase()}/cuisines/${cuisine}${city ? `/${city}` : ''}`,
        }),
      );

      return {
        ...state,
        alternateUrls,
      };
    }
    default:
      return state;
  }
}
